import { useTranslation } from "react-i18next";
import { Badge } from "components/ui/badge";
import { getStatusPresentation } from "../utils/manuscriptProcessingStatusPresentation";

export const ManuscriptProcessingStatusBadge = ({
  status,
}: {
  status: string;
}) => {
  const { t } = useTranslation("settings");
  const presentation = getStatusPresentation(status);

  if (!presentation) {
    return <Badge variant="secondary">{status}</Badge>;
  }

  const { Icon, badgeVariant, label } = presentation;

  return (
    <Badge variant={badgeVariant}>
      <Icon aria-hidden />
      {label(t)}
    </Badge>
  );
};
